module.exports = __webpack_public_path__ + "static/media/m_b_12.b8ea0163.png";